import { render, staticRenderFns } from "./DataDeliveryChartCompact.vue?vue&type=template&id=4026c1f4&scoped=true&"
import script from "./DataDeliveryChartCompact.vue?vue&type=script&lang=ts&"
export * from "./DataDeliveryChartCompact.vue?vue&type=script&lang=ts&"
import style0 from "./DataDeliveryChartCompact.vue?vue&type=style&index=0&id=4026c1f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4026c1f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
